import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { HumanizeDatePipe } from './humanize-date.pipe';
import { Options } from 'humanize-duration';
import { CountDownPipe } from './count-down.pipe';
import { EMPTY, Observable, map, of, takeUntil, takeWhile, tap, timer } from 'rxjs';
import { getCurrentCentralEuropeDate } from '../functions/get-current-central-europe-date.func';

@Pipe({
    name: 'humanizeIfInRangeDate',
    pure: true,
    standalone: false
})
export class HumanizeIfInRangeDatePipe implements PipeTransform {

  constructor(private readonly datePipe: DatePipe,
    private readonly humanizeDatePipe: HumanizeDatePipe) {
  }

  transform(value: Date | undefined | null, daysRange: number = 1): Observable<string | null | undefined> {
    if (!value) return of(null);
    const localDate = this.convertToLocalTimezone(value);

    const limitDate = new Date()
    limitDate.setDate(new Date().getDate() - daysRange)

    if (localDate < limitDate || localDate > limitDate)
      return of(this.datePipe.transform(localDate, 'dd/MM/yyyy HH:mm'))
    else if (localDate > new Date()) {
      return this.getCountUp(localDate).pipe(map(tiks => 'tra ' + this.humanizeDatePipe.transform(tiks, this.humanizeConfig)))
    }
    else {
      return this.getCountUp(localDate).pipe(map(tiks => this.humanizeDatePipe.transform(tiks, this.humanizeConfig) + ' fa'))
    }

  }

  getCountUp(value: Date | null | undefined): Observable<number> {
    if (!value) return EMPTY

    return timer(0, 1 * 1000).pipe(
      map(() => this.getRemainingTime(value))
    )
  }

  private getRemainingTime(arrivalDate: Date): number {
    return new Date(arrivalDate.getTime() - getCurrentCentralEuropeDate().getTime()).getTime()
  }

  private readonly humanizeConfig: Options = {
    language: 'it',
    units: ['d', 'h', 'm'],
    largest: 1,
    round: true
  }

  private convertToLocalTimezone(date: Date): Date {
    const localTimezoneOffset = date.getTimezoneOffset() * 60000
    return new Date(date.getTime() - localTimezoneOffset)
  }
}
